// 
// ─── IMPORTING NECESSARY ELEMENTS ───────────────────────────────────────
//
import { React, useState } from 'react';
import { NavLink } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { SCAN_STORE_ENABLED } from '../../contexts/Features';

// 
// ─── IMPORTING COMPONENTS ───────────────────────────────────────
//
import ModalScanStore from '../Modals/Qr/Scan/ModalScanStore';
import ModalScanConfirmation from '../Modals/Qr/Success/ModalScanConfirmation';
// Ancien flux : QR perso (tant que SCAN_STORE_ENABLED est à false) et lecteur manager (gains pendant la transition)
import ModalQrCode from '../Modals/Qr/User/ModalQrCode';
import ModalReadQrCode from '../Modals/Qr/Scan/ModalReadQrCode';

// 
// ─── IMPORTING SVG ───────────────────────────────────────
//
import background from '../../assets/static/navbar-70.svg'
import { ReactComponent as ScanQr } from '../../assets/static/scanQr.svg'
// 
// ─── IMPORTING FONTAWESOME ICONS ───────────────────────────────────────
//
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHouse } from '@fortawesome/pro-regular-svg-icons'
import { faQrcode } from '@fortawesome/pro-solid-svg-icons'
import { faGift } from '@fortawesome/pro-regular-svg-icons'
import { faXmark } from '@fortawesome/pro-solid-svg-icons'
import { faLock } from '@fortawesome/pro-regular-svg-icons'
import { faUser } from '@fortawesome/pro-regular-svg-icons'
import { faBarcode } from '@fortawesome/pro-regular-svg-icons'
import { faTag } from '@fortawesome/pro-regular-svg-icons';

// SCSS
import './NavigationFooter.scss'

// 
// ─── COMPONENT DECLARATION ───────────────────────────────────────
//
const NavigationFooter = () => {
  // 
  // ─── STATE DECLARATION ───────────────────────────────────────
  //
  // Modal
  const [openScan, setOpenScan] = useState(false)
  const [confirmation, setConfirmation] = useState(null)
  // Ancien flux : QR perso de l'utilisateur / lecteur du manager
  const [openModal, setOpenModal] = useState(false)
  const [openModalReader, setOpenModalReader] = useState(false)

  // Fontawesome init
  library.add(faHouse, faQrcode, faTag, faGift, faXmark, faLock, faUser, faBarcode)

  // Cookies
  const cookies = new Cookies();
  const userData = cookies.get(process.env.REACT_APP_USER_COOKIE);


  // 
  // ─── COMPONENT RENDER ───────────────────────────────────────
  //
  // Manager (role 3) : barre réduite au lecteur de QR utilisateur. Une fois le
  // scan boutique activé, il ne sert plus qu'à valider les gains déjà reçus.
  if ([3].includes(userData.role)) return <>
    {openModalReader && <ModalReadQrCode open={openModalReader} />}
    <div className="bottom-appbar">
      <div className="tabs">
        <div className="tab tab--left"></div>
        <div className="tab tab--fab">
          <div className='fab' onClick={() => setOpenModalReader(!openModalReader)}>
            {!openModalReader ? <ScanQr className='scanQr' /> : <FontAwesomeIcon className='qr' icon="fa-solid fa-xmark" />}
          </div>
        </div>
        <div className="tab tab--right"></div>
      </div>
    </div>
  </>

  return <>
    {/* QR PERSO DE L'UTILISATEUR (ANCIEN FLUX) */}
    {openModal && <ModalQrCode open={openModal} />}
    {/* SCAN DU QR BOUTIQUE */}
    {openScan && <ModalScanStore
      open={openScan}
      onClose={() => setOpenScan(false)}
      onSuccess={(scan) => { setOpenScan(false); setConfirmation(scan) }}
    />}
    {/* CARTE DE CONFIRMATION */}
    {confirmation && <ModalScanConfirmation
      open={!!confirmation}
      scan={confirmation}
      onClose={() => setConfirmation(null)}
    />}

    <div className="bottom-appbar">
      <img loading="lazy" src={background} alt='background-NavBar' className='background-nav' />

      <div className="tabs">
        <div className="tab tab--left">
          <NavLink to='/' end className={({ isActive }) => isActive ? 'active' : ''}>
            <FontAwesomeIcon className='icons' icon="fa-regular fa-house" />Accueil
          </NavLink>
          <NavLink to='/offres' className={({ isActive }) => isActive ? 'active' : ''}>
            <FontAwesomeIcon className='icons' icon="fa-regular fa-tag" />Offres
          </NavLink>
        </div>
        <div className="tab tab--fab">
          {([1, 2, 4].includes(userData.role)) && (SCAN_STORE_ENABLED
            ? <div className='fab' onClick={() => setOpenScan(!openScan)}>
              {!openScan ? <ScanQr className='scanQr' /> : <FontAwesomeIcon className='qr' icon="fa-solid fa-xmark" />}
            </div>
            : <div className='fab' onClick={() => setOpenModal(!openModal)}>
              {!openModal ? <FontAwesomeIcon className='qr' icon="fa-solid fa-qrcode" /> : <FontAwesomeIcon className='qr' icon="fa-solid fa-xmark" />}
            </div>)}
        </div>
        <div className="tab tab--right">
          {/* Gains déjà reçus : onglet conservé pendant la transition, Enseignes reste accessible depuis l'accueil */}
          <NavLink to='/gains' className={({ isActive }) => isActive ? 'active' : ''}>
            <FontAwesomeIcon className='icons' icon="fa-regular fa-gift" />Gains
          </NavLink>
          <NavLink to='/mon-compte' className={({ isActive }) => isActive ? 'active' : ''}> <FontAwesomeIcon className='icons' icon="fa-regular fa-user" /> Profil</NavLink>
        </div>
      </div>
    </div>
  </>
};

export default NavigationFooter;